import { Injectable } from '@angular/core';
import {HttpClient, HttpParams} from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class SalesrefService {


  public refinfo = {['isValid']: false, ['code']: 0};

  constructor(private http: HttpClient) { }


  public lookupSalesId(sid: string) {
    let params = new HttpParams().set('code', sid);
    return this.http.get(`/api/validref`, {params});
  }

}
